<template>
    <div class="form-group">
        <label class="form-label">{{ label }}</label>
        <p class="col-span-8">{{ value }}</p>
    </div>
</template>

<script>
import FormLabel from "./FormLabel";

export default {
    name: "FormConfirm",
    components: {FormLabel},
    props: {
        label: {
            type: String,
        },
        value: {
            type: String | Number,
        }
    }
}
</script>

<style scoped>

</style>
